import React from "react";
import {
  HomeRounded,
  InventoryRounded,
  OpenInNew,
  ReceiptRounded,
} from "@mui/icons-material";
import Dashboard from "../pages/Dashboard/Dashboard.tsx";
import { NavigationPageItem } from "../types/types.ts";
import { IconButton, SvgIcon } from "@mui/material";
import ClientHub from "../pages/ClientHub/ClientHub.tsx";
import { ReactComponent as SharepointIcon } from "../styles/assets/logo_sharepoint.svg";
import { ReactComponent as PowerBIIcon } from "../styles/assets/logo_powerbi.svg";
import Insights from "../pages/Insights/Insights.tsx";
import CreateOrder from "../pages/Orders/Create/CreateOrder.tsx";
import OrdersAdmin from "../pages/Orders/Admin/OrdersAdmin.tsx";
import OrderSummary from "../pages/Orders/Summary/OrderSummary.tsx";
import LoadBoard from "../pages/Loads/LoadBoard/LoadBoard.tsx";
import RateRequest from "../pages/Rate/RateRequest/RateRequest.tsx";
import RateHistory from "../pages/Rate/RateHistory/RateHistory.tsx";
import Invoice from "../pages/Invoice/Invoice.tsx";

// import ARReport from "../pages/Invoice/ARReport/ARReport.tsx";
// import AccountsPayable from "../pages/Invoice/AccountsPayable/AccountsPayable.tsx";
// import AccountsReceivable from "../pages/Invoice/AccountsRecievable/AccountsRecievable.tsx";
// import ListBillReport from "../pages/Invoice/ListBIllReport/ListBillReport.tsx";

import CustomerInvoiceSummary from "../pages/Invoice/CustomerInvoiceSummaryPage/CustomerInvoiceSummaryPage.tsx";

const HOME: NavigationPageItem = {
  kind: "page",
  segment: "home",
  title: "Home",
  icon: (
    <HomeRounded
      sx={{
        width: "40px",
        height: "40px",
        backgroundColor: "#FFFFFF",
        color: "#00263A",
        border: "2px solid #44D62C",
        borderRadius: "50%",
        padding: "5px",
      }}
    />
  ),
  router: {
    path: "",
    Component: Dashboard,
    index: true,
  },
};

const CLIENTHUB: NavigationPageItem = {
  kind: "page",
  segment: "sharepoint",
  title: "Client Hub",
  icon: <SvgIcon component={SharepointIcon} inheritViewBox />,
  router: {
    path: "client-hub",
    Component: ClientHub, // Keep component reference for router structure
  },
  externalRedirect: true,
  action: (
    <IconButton>
      <OpenInNew
        sx={{
          width: "24px",
          height: "24px",
          backgroundColor: "#FFFFFF",
          color: "#00263A",
          borderRadius: "50%",
        }}
      />
    </IconButton>
  ),
};

const POWERBI: NavigationPageItem = {
  kind: "page",
  segment: "powerbi",
  title: "Insights",
  icon: <SvgIcon component={PowerBIIcon} inheritViewBox />,
  router: {
    path: "insights",
    Component: Insights, // Keep component reference for router structure
  },
  externalRedirect: true,
  action: (
    <IconButton>
      <OpenInNew
        sx={{
          width: "24px",
          height: "24px",
          backgroundColor: "#FFFFFF",
          color: "#00263A",
          borderRadius: "50%",
        }}
      />
    </IconButton>
  ),
};

const ORDERENTRY: NavigationPageItem = {
  kind: "page",
  segment: "order-entry",
  title: "Order Entry",
  router: {
    path: "order-entry",
    Component: CreateOrder,
    index: true,
  },
};

const ORDERSUMMARY: NavigationPageItem = {
  kind: "page",
  segment: "order-summary",
  title: "Order Summary",
  router: {
    path: "order-summary",
    Component: OrderSummary,
  },
};

const ORDERSADMIN: NavigationPageItem = {
  kind: "page",
  segment: "orders-admin",
  title: "Admin",
  router: {
    path: "admin",
    Component: OrdersAdmin,
    index: true,
  },
};

const QUOTEREQUEST: NavigationPageItem = {
  kind: "page",
  segment: "quote_request",
  title: "Quote Request",
  router: {
    path: "quote-request",
    Component: RateRequest,
  },
};

const QUOTEHISTORY: NavigationPageItem = {
  kind: "page",
  segment: "quote_history",
  title: "Quote History",
  router: {
    path: "quote-history",
    Component: RateHistory,
  },
};

// const ACCOUNTSPAYABLE: NavigationPageItem = {
//   kind: "page",
//   segment: "accounts_payable",
//   title: "Accounts Payable",
//   router: {
//     path: "accounts-payable",
//     Component: AccountsPayable,
//   },
// };

// const ACCOUNTSRECIEVABLE: NavigationPageItem = {
//   kind: "page",
//   segment: "accounts_receivable",
//   title: "Accounts Receivable",
//   router: {
//     path: "accounts-receivable",
//     Component: AccountsReceivable,
//   },
// };

// const ARREPORT: NavigationPageItem = {
//   kind: "page",
//   segment: "ar_report",
//   title: "AR Report",
//   router: {
//     path: "ar-report",
//     Component: ARReport,
//   },
// };

// const LISTBILLREPORT: NavigationPageItem = {
//   kind: "page",
//   segment: "list_bill_report",
//   title: "List Bill Report",
//   router: {
//     path: "list-bill-report",
//     Component: ListBillReport,
//   },
// };

const INVOICE: NavigationPageItem = {
  kind: "page",
  segment: "invoices",
  title: "Invoice",
  icon: (
    <ReceiptRounded
      sx={{
        width: "40px",
        height: "40px",
        backgroundColor: "#FFFFFF",
        color: "#00263A",
        border: "2px solid #44D62C",
        borderRadius: "50%",
        padding: "5px",
      }}
    />
  ),
  router: {
    path: "invoice",
    Component: CustomerInvoiceSummary,
  },
};

const LOADBOARD: NavigationPageItem = {
  kind: "page",
  segment: "loads",
  title: "Load Board",
  icon: (
    <InventoryRounded
      sx={{
        width: "40px",
        height: "40px",
        backgroundColor: "#FFFFFF",
        color: "#00263A",
        border: "2px solid #44D62C",
        borderRadius: "50%",
        padding: "5px",
      }}
    />
  ),
  router: {
    path: "load-board",
    Component: LoadBoard,
  },
};

export {
  HOME,
  CLIENTHUB,
  POWERBI,
  ORDERENTRY,
  ORDERSUMMARY,
  ORDERSADMIN,
  QUOTEREQUEST,
  QUOTEHISTORY,
  LOADBOARD,
  INVOICE,
};
